module.exports = __webpack_public_path__ + "img/cf2be00.png";